import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import Modal from "./Modal"; // Adjust the path as needed
import { useEventContext } from "../util/EventProvider";
import "./PreCheckOut.scss";
import SkeletonLoader from "./Skeleton";
import SkeletonLoaderTwo from "./SkeletonTwo";
import EventMetadata from "../components/EventMetaData";

let itemViewTracked = false; // Flag to track if the item view has been pushed

const trackItemView = (selectedEvent) => {
  if (!selectedEvent) {
    console.warn("selectedEvent is not defined");
    return;
  }

  if (itemViewTracked) {
    console.log("Item view has already been tracked.");
    return;
  }

  const itemViewEvent = {
    event: "view_item",
    ecommerce: {
      currency: "USD",
      items: [
        {
          item_name: selectedEvent.name || "Unknown Event",
          item_id: selectedEvent.id || "Unknown ID",
          price: selectedEvent?.prices?.[0]?.price || 0, // Adjust depending on structure
          item_category: selectedEvent.attribute_EventCategory || "Jazz Show",
          item_variant: selectedEvent.ticketTypeName || "General Admission",
        },
      ],
    },
  };

  console.log("Tracking item view with window.gtag:", itemViewEvent);
  window.gtag("event", "view_item", itemViewEvent);
  itemViewTracked = true;
};

export function PreCheckOut({}) {
  const {
    fullEventId,
    customEventDetails,
    eventInstances,
    loading,
    priceDetails,
    ticketData,
    studentPrices,
    generalAdmTicketTypeId,
    studentTicketTypeId,
    ticketTypeNames,
    availableStatus,
    customItems,
    shortenedEventId, // Correct spelling here
  } = useEventContext();

  const [resizeKey, setResizeKey] = useState(0);

  const eventId = fullEventId;

  const triggerResize = () => {
    if (typeof window.parentIFrame?.size === "function") {
      setTimeout(() => {
        window.parentIFrame.size();
        console.log("Resize triggered", new Date().toLocaleTimeString());
        setResizeKey((prev) => prev + 1); // Force re-render
      }, 300); // Longer delay for dynamic content
    } else {
      console.warn("parentIFrame not available");
    }
  };

  useEffect(() => {
    console.log("ParentIFrame available?", !!window.parentIFrame);
  }, []);

  //const { eventId } = useParams();
  const [selectedDateButton, setSelectedDateButton] = useState([]);
  const [eventChosen, setEventChosen] = useState([]);
  const [subtotal, setSubtotal] = useState(0); // Initialize subtotal state
  const [selectedTimeButton, setSelectedTimeButton] = useState(null);
  const [selectedEventInstance, setSelectedEventIntance] = useState([]);
  const [seatingId, setSeatingId] = useState([]);
  const [ticketDataLoaded, setTicketDataLoaded] = useState(false);
  // State for ticket selections
  const [ticketSelections, setTicketSelections] = useState([]);
  const [ticketLimit, setTicketLimit] = useState("");
  const [subtotalToZero, setSubtotalToZero] = useState(true); // Initially set to true assuming all options are at their default value
  const [promoCode, setPromoCode] = useState("");
  const [totalTicketsSelected, setTotalTicketsSelected] = useState(0);
  const [total, setTotal] = useState(0); // Initialize subtotal state
  // Inside your component
  const [timeButtonClickCounter, setTimeButtonClickCounter] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    const isDataReady =
      ticketData &&
      Object.keys(ticketData).length > 0 && //Checks if ticketData has keys
      eventId &&
      customEventDetails?.length > 0 &&
      !loading;

    setTicketDataLoaded(isDataReady);
  }, [ticketData, eventId, customEventDetails, loading]);

  // After API data loads
  useEffect(() => {
    if (ticketDataLoaded && ticketSelections.length > 0) {
      triggerResize();
    }
  }, [ticketDataLoaded, ticketSelections]);

  useEffect(() => {
    const debugSpacing = () => {
      const allElements = Array.from(document.querySelectorAll("*"));
      const bottomElements = allElements
        .filter((el) => {
          const rect = el.getBoundingClientRect();
          return rect.bottom > window.innerHeight - 20;
        })
        .map((el) => {
          const rect = el.getBoundingClientRect(); // Define rect here again
          return {
            element: el.tagName,
            class: el.className,
            id: el.id,
            bottom: rect.bottom,
          };
        });
      triggerResize();
    };

    const timer = setTimeout(debugSpacing, 500);
    return () => clearTimeout(timer);
  }, [ticketSelections]);

  useEffect(() => {
    // Fix common spacing offenders
    const style = document.createElement("style");
    style.textContent = `
      body > *:last-child {
        margin-bottom: 0 !important;
      }
      .event-footer, [class*="-container"] {
        padding-bottom: 0 !important;
      }
    `;
    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    // Add styles to the root element when modal is open
    if (modalOpen) {
      document.documentElement.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.documentElement.style.overflow = ""; // Restore default overflow behavior
    }

    return () => {
      // Reset styles when component unmounts
      document.documentElement.style.overflow = "";
    };
  }, [modalOpen]);

  const formatDate = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "long" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${day} • ${month} ${dateNumber}`;
  };

  const formatDateTwo = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "short" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${day}, ${month} ${dateNumber}`;
  };

  const getDayOfWeek = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj
      .toLocaleDateString("en-US", { weekday: "short" })
      .slice(0, 3);
  };

  const getDateNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.getDate();
  };

  const getMonthName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { month: "long" });
  };

  const getYearName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { year: "numeric" });
  };

  const getTimeNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  };

  function scrollToSection(EventInfo) {
    const section = document.getElementById(EventInfo);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Function to extract video ID from YouTube URL
  const extractVideoId = (videoLink) => {
    const urlParams = new URLSearchParams(videoLink.split("?")[1]);
    return urlParams.get("v");
  };

  const handleNavigateBack = () => {
    window.open("https://jazzforumarts.org/events", "_top");
  };

  const eventDetails = customEventDetails;

  // Flatten the event details for further use
  const events = eventDetails.flat();

  // Filter events where isOnSale is true
  const onSaleEvents = events
    .filter((event) => event.isOnSale) // Filter events where isOnSale is true
    .filter((event) => event.start); // Filter events where start is defined

  // Function to find the start time for the first event with the given event ID
  function findStartTimeForEventId(eventId, onSaleEvents) {
    // Iterate through onSaleEvents array
    for (const event of onSaleEvents) {
      // Check if event ID matches the provided event ID
      if (event.id === eventId) {
        // Return the start time of the matched event
        return event.start;
      }
    }
    // If no matching event is found, return null or handle accordingly
    return null;
  }

  const eventDate = findStartTimeForEventId(eventId, onSaleEvents);

  // Extract value from the location.eventDate object
  const eventDateNumber = getDateNumber(eventDate);

  // Extract value from the location.eventDate object
  const eventDateMonth = getMonthName(eventDate);

  // Extract value from the location.eventDate object
  const eventDateYear = getYearName(eventDate);

  // Find the event with the matching eventId
  const selectedEvent = onSaleEvents.filter((event) => event.id === eventId);

  // Find all events with the matching eventDate
  const selectedDate = selectedEvent.filter(
    (event) =>
      getDateNumber(event.start) === eventDateNumber &&
      getMonthName(event.start) === eventDateMonth &&
      getYearName(event.start) === eventDateYear
  );

  const MAX_SELECTIONS = 1; // Define the maximum number of selections allowed

  console.log(selectedDate);

  useEffect(() => {
    console.log("Selected Event:", eventDate);
    console.log("Loading State:", loading);

    if (selectedEvent && !loading) {
      trackItemView(selectedEvent);
    } else {
      console.warn("Conditions for tracking item view are not met:", {
        selectedEvent,
        loading,
      });
    }
  }, [selectedEvent, loading]); // Dependencies include selectedEvent and loading

  // Function to handle selection of dates
  const handleDateButtonSelection = (date) => {
    setSelectedTimeButton(null);
    resetSubtotal(); // Reset subtotal to zero
    // Toggle selection of dates
    if (selectedDateButton.includes(date)) {
      setSelectedDateButton(
        selectedDateButton.filter((selectedDate) => selectedDate !== date)
      );
    } else {
      // Remove the last entry if the array length exceeds the maximum allowed
      if (selectedDateButton.length >= MAX_SELECTIONS) {
        const updatedSelections = selectedDateButton.slice(1); // Remove the first element
        setSelectedDateButton([...updatedSelections, date]);
      } else {
        setSelectedDateButton([...selectedDateButton, date]);
      }
    }
  };

  // Function to handle click on date button
  const handleClickDateButton = (date) => {
    handleDateButtonSelection(date); // Call the handleDateButtonSelection function
  };

  const resetAllSelectOptionsToZero = () => {
    const selectElements = document.querySelectorAll("[id^=ticketSelect_]");
    selectElements.forEach((selectElement) => {
      selectElement.value = "0";
    });
    resetSubtotal();
  };

  // Function to check if a time button should be clickable
  const isTimeButtonClickable = (startTime, clickedDate, index) => {
    setTimeButtonClickCounter((prevCounter) => {
      const newCounter = prevCounter + 1;

      // Reset ticket selections to 0
      setTicketSelections((prevSelections) => {
        return prevSelections.map((ticket) => ({
          ...ticket,
          quantity: 0,
        }));
      });

      // Reset all select options to 0
      resetAllSelectOptionsToZero();

      //console.log("Time button clicked count:", newCounter);
      return newCounter;
    });

    const eventChosen = eventDetails.filter((item) => item.start === startTime);
    setEventChosen(eventChosen);
    console.log("Instance Chosen:", eventChosen);
    if (eventChosen) {
      const eventDate = new Date(eventChosen.start).toDateString();
      setSelectedTimeButton(startTime);
      setSelectedEventIntance(eventChosen[0].instanceId);
      setSeatingId(eventChosen[0].planId);
      setTicketSelections(eventChosen[0].ticketData || []); // Ensure ticketData is an array
      //toast('Cannot select more than available seats:')

      // Call the custom hook to reset select options

      return eventDate === clickedDate;
    }
    return false;
  };

  // Function to handle change in ticket selection
  const handleTicketChange = (index, value, limit) => {
    setTicketSelections((prevSelections) => {
      // Create a new array with the updated quantity for the selected ticket
      const updatedTicketSelections = [...prevSelections];

      // Ensure the ticket at the specified index exists
      if (!updatedTicketSelections[index]) {
        console.error(`Ticket selection at index ${index} does not exist.`);
        return prevSelections; // Return previous state to avoid updates
      }

      // Update the quantity for the selected ticket
      updatedTicketSelections[index].quantity = value;

      // Calculate total number of tickets selected
      const totalTicketsSelected = updatedTicketSelections.reduce(
        (total, ticket) => {
          return total + (ticket.quantity || 0);
        },
        0
      );

      if (totalTicketsSelected <= limit) {
        // Set the updated selections and total tickets selected
        setTotalTicketsSelected(totalTicketsSelected);
        // Set the ticket limit outside the state update to avoid unnecessary renders
        setTicketLimit(limit);
        // Calculate the new subtotal
        calculateSubtotal(updatedTicketSelections);
        //toast('Cannot select more than available seats:', limit)
        return updatedTicketSelections;
      } else {
        // Rollback the quantity change for the current ticket
        updatedTicketSelections[index].quantity -= value;
        resetSubtotal();
        resetAllSelectOptionsToZero();
        setModalMessage(`There ${
          limit === 1 ? "is" : "are"
        } only ${limit} seat${limit === 1 ? "" : "s"} 
          available. Please select accordingly.`);
        setModalOpen(true);
        //console.log('Cannot select more than available seats:', limit);
        return prevSelections; // Return the previous state to avoid updates
      }
    });
  };

  // Function to calculate subtotal based on ticket selections
  const calculateSubtotal = (updatedTicketSelections) => {
    let total = 0;
    ticketSelections.forEach((ticket) => {
      // Ensure ticket object has necessary properties
      if (
        ticket.ticketAmount !== undefined &&
        ticket.commissionAmount !== undefined &&
        ticket.quantity !== undefined
      ) {
        // Calculate total for each ticket type
        total +=
          (ticket.ticketAmount + ticket.commissionAmount) * ticket.quantity;
      }
    });
    setSubtotal(total.toFixed(2));
    setTotal(total.toFixed(2)); // Update the total state
    if (total === 0) {
      //console.log(total);
      setSubtotalToZero(true);
    } else {
      //console.log(total);
      setSubtotalToZero(false);
    }
  };

  // Function to reset subtotal
  const resetSubtotal = () => {
    setSubtotal(0); // Set subtotal to zero
    setSubtotalToZero(true);
    setTotalTicketsSelected(0); // Reset total tickets selected to zero
  };

  // Function to handle the input change
  const handlePromoCodeChange = (event) => {
    setPromoCode(event.target.value);
  };

  // Function to handle sending the promo code to the basket
  const handlePromoCode = async () => {
    console.log("Promo Code:", promoCode);

    try {
      const response = await fetch(
        `https://events.jazzforumarts.org/jazzforumarts/api/v3/basket`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            promoCode: promoCode,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send promo code to basket");
      }

      console.log("Promo code sent to basket successfully!");
      // You can perform further actions here if needed
    } catch (error) {
      console.error("Error sending promo code to basket:", error.message);
    }
  };
  //const remainingTickets = 10 - ticketSelections.reduce((total, ticket) => total + ticket.quantity, 0);

  const handleAddToCart = () => {
    // Call to push data to the data layer when the user adds an item to the cart
    prepareDataLayer();
    console.log("Item added to cart.");

    // You can also add any additional logic related to adding the item to the cart here
  };

  // Separate function to handle the data layer push
  const prepareDataLayer = () => {
    // Assuming selectedEventInstance and ticketSelections are available
    pushItemAddedDataLayer(selectedEventInstance, ticketSelections);
  };

  // Function to push item data to the data layer
  const pushItemAddedDataLayer = (selectedEvent, ticketSelections) => {
    if (!selectedEvent) {
      console.warn("No event data provided to pushItemAddedDataLayer");
      return; // Exit early if selectedEvent is undefined or null
    }

    // Check if ticketSelections is defined and is an array
    if (!Array.isArray(ticketSelections) || ticketSelections.length === 0) {
      console.warn("ticketSelections is not defined or is not an array");
      return; // Exit early if ticketSelections is not an array or is empty
    }

    // Initialize an empty array for items to be pushed to gtag
    const itemsForGtag = [];

    // Loop through each ticket selection
    ticketSelections.forEach((ticket) => {
      // Loop based on the quantity of tickets selected for this type
      for (let i = 0; i < ticket.quantity; i++) {
        // Prepare data for each ticket
        itemsForGtag.push({
          item_name: selectedEvent.name || "Unknown Event",
          item_id: selectedEvent.id || "Unknown ID",
          price: Array.isArray(selectedEvent.prices)
            ? selectedEvent.prices[0] // Assuming price is the same for all tickets
            : selectedEvent.prices, // Handle case if prices is a single value
          item_category: selectedEvent.attribute_EventCategory || "Jazz Show",
          item_variant: selectedEvent.ticketTypeName || "General Admission",
        });
      }
    });

    // Use gtag to send the add_to_cart event
    window.gtag("event", "add_to_cart", {
      currency: "USD", // Set currency to USD
      items: itemsForGtag, // Include all items with their quantity
    });

    // Log for debugging
    console.log("gtag event sent:", {
      event: "add_to_cart",
      currency: "USD",
      items: itemsForGtag,
    });
  };

  const handleCheckout = () => {
    if (!loading) {
      // Call handleAddToCart to push data to the data layer
      handleAddToCart();

      // Initialize an empty array to store ticket request objects
      const requestBody = [];

      // Loop through each ticket selection
      ticketSelections.forEach((ticket) => {
        // Loop based on the quantity of tickets selected for this type
        for (let i = 0; i < ticket.quantity; i++) {
          // Construct a request object for each ticket and add it to the requestBody array
          requestBody.push({
            instance: selectedEventInstance,
            seatingPlan: seatingId,
            type: ticket.ticketTypeId, // Using ticketTypeId from ticketSelections
          });
        }
      });

      // Log the requestBody
      console.log("Request Body:", requestBody);

      // Make the POST request
      fetch(
        "https://events.jazzforumarts.org/jazzforumarts/api/v3/basket/tickets",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          credentials: "include", // Include cookies
        }
      )
        .then((response) => {
          if (response.ok) {
            console.log("Request successful");
            console.log(requestBody);
            // Open a new tab with the external URL
            window.open("https://jazzforumarts.org/cart/", "_top");
          } else {
            // Handle error response
            console.error("Request failed with status:", response.status);
            // Optionally, you can extract error information from the response body
            response.json().then((errorData) => {
              console.error("Error:", errorData);
              // Optionally, you can display an error message to the user
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          // Optionally, you can display an error message to the user
        })
        .finally(() => {
          // Reset loading state after the operation completes
          //setLoading(false);
        });
    }
  };

  const elRef = useRef();

  useLayoutEffect(() => {
    if (elRef.current) {
      // Apply styles to the first child of the div
      const firstChild = elRef.current.firstElementChild;
      if (firstChild) {
        firstChild.style.fontFamily = "Montserrat, Poppins, sans-serif";
        firstChild.style.textTransform = "none";
        firstChild.style.fontStyle = "normal";
        firstChild.style.color = "white";
        firstChild.style.paddingBottom = "10px";
        firstChild.style.paddingRight = "0px";
        firstChild.style.margin = "0";
        firstChild.style.fontSize = "18px";
        firstChild.style.letterSpacing = "-0.5px";
      }
    }
  }, [selectedDate]);

  return (
    <>
     <EventMetadata event={selectedEvent} />
      <div
        className="animate-fadeIn md:ml-25 antialiased Precheckout"
        style={{
          minHeight: "auto",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
          padding: "0px 10px",
          justifyContent: "flext-start",
        }}
      >
        {" "}
        {/* Ensure each key is unique */}
        <div
          style={{
            alignItems: "center",
            justifyContent: "flex-start",
            paddingBottom: "5px",
          }}
        >
          <button
            onClick={handleNavigateBack}
            style={{
              width: "auto",
              maxWidth: "100%",
              fontFamily: "Montserrat, Poppins, sans-serif",
              textTransform: "uppercase",
              //letterSpacing: "1.5px",
              fontSize: "1.2rem",
              height: "40px",
              background: "none",
              border: "none",
              borderRadius: "none",
              display: "inline-flex",
              lineHeight: "1.5rem",
              alignItems: "center",
              justifyContent: "flex-start",
              padding: "0 20px !important", // Override Elementor padding
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "white",
              textDecoration: "none", // Remove default link underline
            }}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 24"
                strokeWidth={3}
                stroke="currentColor"
                className="w-3 h-3"
                style={{ marginRight: "5px", cursor: "pointer" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                />
              </svg>
              <span
                className="leading-tight text-xxm sm:text-xl"
                style={{
                  width: "auto",
                  maxWidth: "100%",
                  fontFamily: "Montserrat, Poppins, sans-serif",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                See all events
              </span>
            </span>
          </button>
        </div>
        {/* Check if there is at least one event in selectedDate */}
        {selectedDate.length > 0 && (
          <li
            className="content-center"
            key={selectedDate[0].instanceId}
            style={{ minHeight: "200px", minWidth: "100%", maxWidth: "100%" }}
          >
            {/*existing event instance rendering logic */}
            <div className="grid place-content-center gap-1 grid-cols-1">
              <div style={{ width: "fit-content" }}>
                <div className="flex flex-col sm:flex-row">
                  {/* Render the event image */}
                  <div className="pb-2">
                    <img
                      src={selectedDate[0].imageUrl}
                      alt={selectedDate[0].name}
                      className="object-cover w-full h-full"
                      style={{
                        objectFit: "contain",
                        objectPosition: "top", // Position the image at the top
                      }}
                    />
                  </div>
                  {/* Render the event information */}
                  <div className="w-full pb-2 sm:px-5">
                    <h3
                      className="text-3xl text-left"
                      style={{
                        fontFamily: "Norwester, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontStyle: "normal",
                        color: "white",
                        lineHeight: "1", // Increase the line height (leading)
                      }}
                    >
                      {selectedDate[0].name}
                    </h3>
                    <div className="text-2xl">
                      <h4
                        style={{
                          fontFamily: "Norwester, Poppins, sans-serif",
                          textTransform: "uppercase",
                          fontStyle: "normal",
                          color: "white",
                          paddingBottom: "3px",
                          margin: "0", // Add margin
                        }}
                      >
                        {selectedDate[0].attribute_Subtitle}
                      </h4>
                    </div>
                    <div className="pb-2">
                      <h1 className="text-left" style={{ margin: "0" }}>
                        <p
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "none",
                            fontStyle: "normal",
                            color: "white",
                            paddingBottom: "3px",
                            fontWeight: "bold",
                            margin: "0", // Add margin
                          }}
                        >
                          {selectedDate[0].attribute_SpecialInformation}
                        </p>
                      </h1>
                    </div>
                    <div className="pb-2">
                      <h1 className="text-left" style={{ margin: "0" }}>
                        <p
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "none",
                            fontStyle: "normal",
                            color: "white",
                            paddingBottom: "3px",
                            margin: "0", // Add margin
                          }}
                        >
                          {selectedDate[0].attribute_FeaturedArtists}
                        </p>
                      </h1>
                    </div>
                    <div>
                      <div>
                        <button
                          onClick={() => scrollToSection("sectionId")}
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            //letterSpacing: "1.5px",
                            fontSize: "1.2rem",
                            height: "40px",
                            background: "none",
                            border: "none",
                            borderRadius: "none",
                            display: "inline-flex",
                            lineHeight: "1.5rem",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            padding: "0 20px !important", // Override Elementor padding
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "white",
                            textDecoration: "none", // Remove default link underline
                          }}
                        >
                          <span
                            onClick={() => scrollToSection("EventInfo")}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="2.5"
                              stroke="currentColor"
                              class="w-3 h-3"
                              style={{
                                marginRight: "5px",
                                cursor: "pointer",
                              }}
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
                              />
                            </svg>
                            <span
                              className="leading-tight text-xxm sm:text-xl"
                              style={{
                                width: "auto",
                                maxWidth: "100%",
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              Scroll to see more event info
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-row sm:flex-col">
                  <div className="w-full pb-10">
                    <section className="ExtraInfo">
                      {/* Render tags and event category within a single div */}
                      <div className="text-align-center">
                        {/* Conditionally render tag 1 if it's not null */}
                        {selectedDate[0].attribute_EventTag1 && (
                          <label
                            className="inline-flex justify-center items-center text-xxxs sm:text-ms"
                            style={{
                              padding: "4px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: ".8rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              marginRight: "6px", // Add margin between tags
                            }}
                          >
                            {selectedDate[0].attribute_EventTag1}
                          </label>
                        )}
                        {/* Conditionally render tag 2 if it's not null */}
                        {selectedDate[0].attribute_EventTag2 && (
                          <label
                            className="inline-flex justify-center items-center text-xxxs sm:text-ms"
                            style={{
                              padding: "4px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: ".8rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              marginRight: "6px", // Add margin between tags
                            }}
                          >
                            {selectedDate[0].attribute_EventTag2}
                          </label>
                        )}
                        {/* Conditionally render tag 3 if it's not null */}
                        {selectedDate[0].attribute_EventTag3 && (
                          <label
                            className="inline-flex justify-center items-center text-xxxs sm:text-ms"
                            style={{
                              padding: "4px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: ".8rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              marginRight: "3px", // Add margin between tags
                            }}
                          >
                            {selectedDate[0].attribute_EventTag3}
                          </label>
                        )}
                        {/* Conditionally render Event Category if it's not null */}
                        {selectedDate[0].attribute_EventCategory && (
                          <p
                            className="inline-flex justify-center items-center text-xxxs sm:text-ms"
                            style={{
                              padding: "4px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: ".8rem",
                              //background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              fontStyle: "italic", // Apply cursive font style
                              marginRight: "3px", // Add margin between tags
                            }}
                          >
                            {selectedDate[0].attribute_EventCategory}
                          </p>
                        )}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </li>
        )}
        {/* Ticket Date/Time Section */}
        {loading ? (
          <SkeletonLoader /> // Show skeleton loader while loading
        ) : (
          <div
            className=""
            style={{
              width: "auto" /* Set the width of the square */,
              height: "auto" /* Set the height of the square */,
              background: "#2D2D2D" /* Set the background color */,
              display: "flex" /* Use flexbox for centering */,
              justifyContent: "left" /* Center horizontally */,
              alignItems: "left" /* Center vertically */,
              margin: "0 auto" /* Center horizontally */,
              padding: "0px 20px",
              minHeight: "100%",
              maxHeight: "100%",
              width: "100%",
              height: "100%",
            }}
          >
            <section style={{ marginTop: "20px" }}>
              <div
                className="instructions"
                style={{
                  background: "#0D0D0D",
                  padding: "13px", // Add equal padding
                  marginTop: "13px", // Add margin above this div
                  display: "flex", // Use flexbox to center content
                  justifyContent: "center", // Center horizontally
                  alignItems: "center", // Center vertically
                  textAlign: "center", // Center text within the div
                  flexDirection: "column", // Stack children vertically
                }}
              >
                <p
                  style={{
                    fontWeight: "100", // Make the font thinner
                    color: "white",
                    letterSpacing: "2px",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    fontFamily: "Montserrat, Poppins, sans-serif",
                    lineHeight: "1", // Increase line height
                  }}
                >
                  First choose date. Then choose time.
                </p>
              </div>
              <div>
                {/* Your existing JSX for ticket selection */}
                <Modal
                  isOpen={modalOpen}
                  onClose={() => setModalOpen(false)}
                  message={modalMessage}
                />
              </div>
              <div className="py-10">
                {/* Section: Render Dates and Times for Chosen Event */}

                {/* Get unique dates */}
                {selectedEvent
                  .map((event) => new Date(event.start).toDateString()) // Get unique dates as strings
                  .filter((date, index, self) => self.indexOf(date) === index) // Filter unique dates
                  .map((date, index) => {
                    const currentDate = new Date();
                    return {
                      date: date,
                      isFirstDate: index === 0 && events.length > 0,
                      events: selectedEvent.filter(
                        (event) =>
                          new Date(event.start).toDateString() === date &&
                          new Date(event.start) > currentDate
                      ),
                    };
                  })
                  .filter(({ events }) => events.length > 0) // Filter out dates with no valid events
                  .map(({ date, events, isFirstDate }) => (
                    <div key={date}>
                      <div
                        className="flex items-left"
                        style={{
                          color: "white",
                          lineHeight: "1",
                          fontFamily: "Norwester, Poppins, sans-serif",
                          textTransform: "uppercase",
                        }}
                      >
                        {isFirstDate && (
                          <h4
                            style={{
                              color: "white",
                              marginRight: "90px", // Add margin between Choose Date and Choose Time
                            }}
                            className="text-[20px] md:text-[24px]"
                          >
                            Choose Date:
                          </h4>
                        )}
                          {/* Render times for each unique date */}
                          {isFirstDate && (
                            <h4
                              id="fixChooseTime"
                              style={{
                                color: "white",
                                fontSize: "24px",
                                paddingBottom: "10px",
                              }}
                            >
                              Choose Time:
                            </h4>
                          )}
                        </div>
                        <div className="flex flex-grid-2">
                          <div className="date-button">
                            <button
                              className={`text-white`}
                              style={{
                                color: selectedDateButton.includes(date)
                                  ? "white"
                                  : "black",
                                minWidth: "180px",
                                minHeight: "50px",
                                background: selectedDateButton.includes(date)
                                  ? "#009ED0"
                                  : "white",
                                fontSize: ".85rem",
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "uppercase",
                                pointerEvents: !ticketDataLoaded
                                  ? "none"
                                  : "auto",
                                padding: "10px", // Add padding for better symmetry
                              }}
                              onClick={() =>
                                ticketDataLoaded && handleClickDateButton(date)
                              }
                              disabled={!ticketDataLoaded}
                            >
                              <p
                                style={{
                                  fontFamily: "Montserrat, Poppins, sans-serif",
                                }}
                              >
                                {formatDate(date)}
                              </p>
                            </button>
                          </div>
                          {/* Render times for each unique date */}
                          <div
                            className="times-button"
                            style={{ display: "flex", flexWrap: "wrap" }}
                          >
                            {events.map((event, index) => (
                              <div
                                key={event.instanceId}
                                style={{
                                  flexBasis: "10%",
                                  marginBottom: "10px",
                                }}
                              >
                                <button
                                  id="fixDateButton"
                                  className="sm:grid-cols-1 ml-10 text-black"
                                  style={{
                                    marginRight:
                                      index % 1 === 0 ? "-30px" : "0", // Add margin between buttons in pairs

                                    fontSize: ".85rem",
                                    fontFamily:
                                      "Montserrat, Poppins, sans-serif",
                                    textTransform: "uppercase",
                                    color: selectedDateButton.includes(date)
                                      ? "white"
                                      : "black", // Only turn blue when button is active
                                    minWidth: "130px",
                                    minHeight: "50px",
                                    color: "black",
                                    background: "white",
                                    color:
                                      selectedDateButton.includes(date) &&
                                      event.availableStatus === 0 &&
                                      "white", // Only turn blue when button is active
                                    backgroundColor:
                                      event.availableStatus === 0
                                        ? "#B00000"
                                        : selectedTimeButton === event.start
                                        ? "#009ED0"
                                        : "white",
                                    background:
                                      selectedTimeButton !== event.start &&
                                      "white", // Adjusted color condition
                                    color:
                                      selectedTimeButton === event.start &&
                                      "white", // Adjusted color condition
                                    position: "relative", // Position relative for absolute positioning of the icon
                                    transition: "background-color 7s, color 7s", // Transition for background color and text color
                                    transition: "opacity .8s", // Transition for opacity change
                                    opacity:
                                      selectedDateButton.includes(date) &&
                                      event.availableStatus > 0
                                        ? 1
                                        : 0.4, // Set initial opacity
                                    pointerEvents:
                                      selectedDateButton.includes(date) &&
                                      event.availableStatus > 0
                                        ? "auto"
                                        : "none",
                                    borderRadius: ".4px", // Added border-radius for symmetry
                                  }}
                                  onClick={() =>
                                    isTimeButtonClickable(
                                      event.start,
                                      date,
                                      index
                                    )
                                  }
                                >
                                  {/* Conditionally render time, "Sold Out", or "Loading" */}
                                  {ticketDataLoaded ? (
                                    event.availableStatus > 0 ? (
                                      <p
                                        style={{
                                          fontFamily:
                                            "Montserrat, Poppins, sans-serif",
                                        }}
                                      >
                                        {getTimeNumber(event.start)}
                                      </p>
                                    ) : (
                                      <label
                                        style={{
                                          color: "white",
                                          letterSpacing: "1px",
                                          fontSize: ".85rem",
                                          textTransform: "uppercase",
                                          fontFamily:
                                            "Montserrat, Poppins, sans-serif",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontFamily:
                                              "Montserrat, Poppins, sans-serif",
                                          }}
                                        >
                                          Sold Out
                                        </p>
                                      </label>
                                    )
                                  ) : (
                                    <p style={{ color: "white" }}>Loading...</p>
                                  )}
                                  {selectedTimeButton === event.start && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="w-6 h-6"
                                      style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        color: "#009ED0", // Adjust the color of the checkmark icon
                                      }}
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m4.5 12.75 6 6 9-13.5"
                                      />
                                    </svg>
                                  )}
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </section>
          </div>
        )}
        {/* Choose Ticket Section */}
        {selectedDateButton.length > 0 && selectedTimeButton && (
          <div
            className="flex flex-row"
            style={{
              width: "auto" /* Set the width of the square */,
              height: "auto" /* Set the height of the square */,
              background: "#2D2D2D" /* Set the background color */,
              display: "flex" /* Use flexbox for centering */,
              justifyContent: "left" /* Center horizontally */,
              alignItems: "left" /* Center vertically */,
              margin: "0 auto" /* Center horizontally */,
              padding: "0px 20px",
              minHeight: "100%",
              maxHeight: "100%",
              width: "100%",
              height: "100%",
            }}
          >
            <section>
              <div style={{ paddingBottom: "10px" }}></div>
              <div
                style={{
                  color: "white",
                  lineHeight: "1",
                  fontSize: "1rem",
                  fontFamily: "Norwester, Poppins, sans-serif",
                  textTransform: "uppercase",
                  paddingBottom: "10px",
                }}
              >
                <h4
                  style={{
                    color: "white",
                    fontSize: "24px",
                    paddingBottom: "10px",
                  }}
                >
                  Choose Tickets:
                </h4>
              </div>
              <div className="">
                {eventChosen[0]?.ticketData?.map((ticketType, index) => (
                  <div
                    key={index}
                    style={{
                      paddingBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p
                      className="ticket-type-name"
                      htmlFor={`ticketSelect_${index}`}
                      style={{
                        color: "white",
                        maxLines: "2",
                        letterSpacing: "1px",
                        lineHeight: "1",
                        fontSize: "1rem",
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        marginRight: "12px",
                      }}
                    >
                      {ticketType.ticketTypeName}:
                    </p>
                    <select
                      id={`ticketSelect_${index}`}
                      name={`ticketSelect_${index}`}
                      style={{
                        color: "black",
                        height: "40px",
                        minWidth: "80px", // Add minimum width to the select box
                        maxWidth: "100px", // Add minimum width to the select box
                        fontSize: ".8rem",
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        padding: "10px",
                        border: "1px solid #ccc", // Add border for better visibility
                        // Hide the default dropdown arrow
                        appearance: "none",
                        // Adjust the appearance of the custom dropdown arrow
                        backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="black" class="w-6 h-6"%3E%3Cpath stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /%3E%3C/svg%3E')`,
                        backgroundRepeat: "no-repeat",
                        backgroundPositionX: "calc(100% - 18px)",
                        backgroundPositionY: "center",
                        backgroundSize: "16px", // Adjust this value to change the size of the arrow
                      }}
                      defaultValue="0"
                      onChange={(event) =>
                        handleTicketChange(
                          index,
                          parseInt(event.target.value),
                          eventChosen[0].availableStatus
                        )
                      }
                    >
                      {[
                        ...Array(
                          Math.min(26, eventChosen[0].availableStatus + 1)
                        ).keys(),
                      ].map((value) => (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                    {/* Display price and commission */}
                    <div className="flex flex-row items-center">
                      <p
                        style={{
                          color: "white",
                          letterSpacing: "1px",
                          lineHeight: "1",
                          fontSize: "1rem",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          marginLeft: "12px",
                          marginRight: "12px", // Add some margin between the elements
                          whiteSpace: "nowrap", // Prevent wrapping to the next line
                          ...(window.innerWidth <= 540 && {
                            // Apply style only in sm (small) screens
                            marginRight: "10px", // Add margin to move closer to the left
                          }),
                        }}
                      >
                        {`$${ticketType.ticketAmount} `}(+$
                        {parseFloat(ticketType.commissionAmount).toFixed(
                          2
                        )}{" "}
                        fee)
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ paddingBottom: "20px" }}></div>
            </section>
          </div>
        )}
        {/* Apply Discount Section */}
        <div style={{ paddingBottom: "10px" }}>
          <hr
            style={{ borderColor: "black", margin: "0 auto", width: "10%" }}
          />{" "}
          {/* Divider line */}
          {/* Choose Ticket Section */}
          <div
            className="flex flex-row"
            style={{
              width: "auto",
              height: "auto",
              background: "#2D2D2D",
              display: "flex",
              justifyContent: "left",
              alignItems: "left",
              margin: "0 auto",
              paddingBottom: "10px",
              padding: "0px 20px",
            }}
          >
            <section className="flex flex-col sm:flex-row"></section>
          </div>
          {!ticketDataLoaded ? (
            <SkeletonLoaderTwo /> // Show skeleton loader while loading
          ) : (
            <section>
              <div
                style={{
                  fontFamily: "Montserrat, Poppins, sans-serif",
                  textTransform: "none",
                  fontStyle: "normal",
                  color: "white",
                  paddingBottom: "10px",
                  background: "#2D2D2D",
                  padding: "0px 20px",
                  paddingTop: "20px",
                }}
              >
                <div>
                  <p
                    className="leading-tight text-xxm sm:text-xl"
                    style={{
                      color: "white",
                      textTransform: "uppercase",
                      //fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat, Poppins, sans-serif",
                      paddingBottom: "16px",
                    }}
                  >
                    Subtotal: ${subtotal}
                  </p>
                </div>
                <div
                  style={{
                    fontFamily: "Montserrat, Poppins, sans-serif",
                    textTransform: "none",
                    fontStyle: "normal",
                    color: "white",
                    paddingBottom: "20px",
                  }}
                >
                  <button
                    style={{
                      width: "auto",
                      maxWidth: "100%",
                      fontFamily: "Montserrat, Poppins, sans-serif",
                      textTransform: "uppercase",
                      letterSpacing: "2.5px",
                      fontSize: ".8rem",
                      height: "40px",
                      background: "#009ED0",
                      border: "none",
                      borderRadius: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "25px", // Adjust padding here
                      opacity: subtotal === 0 && 0.4, // Set initial opacity
                      opacity: subtotalToZero === true && 0.4, // Set initial opacity
                      pointerEvents: subtotal === 0 && "none",
                      pointerEvents: subtotalToZero === true && "none",
                    }}
                    onClick={() => {
                      handleCheckout();
                    }}
                  >
                    {loading ? "Processing..." : "Add To Cart"}
                    {!loading && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <div>
                  {eventChosen &&
                    eventChosen.length > 0 &&
                    eventChosen[0].start &&
                    subtotal !== 0 &&
                    !subtotalToZero && (
                      <p
                        style={{
                          color: "white",
                          letterSpacing: "1px",
                          lineHeight: "1",
                          fontSize: "1rem",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          fontStyle: "italic",
                        }}
                      >
                        {`You are buying tickets for ${formatDateTwo(
                          eventChosen[0].start
                        )} at ${getTimeNumber(eventChosen[0].start)}`}
                      </p>
                    )}
                </div>
                <div style={{ paddingBottom: "20px" }}></div>
              </div>
            </section>
          )}
        </div>
        {/* Event Info Section */}
        <section
          className="flex flex-col sm:flex-row"
          id="EventInfo"
          style={{
            fontFamily: "Montserrat, Poppins, sans-serif",
            textTransform: "none",
            fontStyle: "normal",
            color: "white",
            paddingTop: "20px",
            paddingBottom: "40px",
            margin: "0", // Add margin
          }}
        >
          {/* Event Info */}
          <div
            className="w-full"
            style={{ marginBottom: "20px", paddingRight: "20px" }}
          >
            <h4
              style={{
                color: "white",
                fontSize: "24px",
                paddingBottom: "12px",
                textTransform: "uppercase",
                fontFamily: "Norwester",
              }}
            >
              Event Info:
            </h4>
            {selectedDate.length > 0 && (
              <div
                ref={elRef}
                dangerouslySetInnerHTML={{
                  __html: selectedDate[0]?.htmlDescription || "",
                }}
              />
            )}
            {/* FB Link */}
            <section
              className="pt-5"
              style={{
                paddingBottom: selectedDate[0]?.attribute_Website
                  ? "15px"
                  : "0px", // Conditional padding
              }}
            >
              {selectedDate[0]?.attribute_RSVPFacebookLink && (
                <div>
                  <a
                    href={selectedDate[0].attribute_RSVPFacebookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }} // Optional: removes underline from the link
                  >
                    <button
                      style={{
                        width: "auto",
                        maxWidth: "100%",
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        letterSpacing: "2.5px",
                        fontSize: ".8rem",
                        height: "40px",
                        background: "#009ED0",
                        border: "none",
                        borderRadius: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "25px",
                      }}
                    >
                      {"RSVP on Facebook"}
                    </button>
                  </a>
                </div>
              )}
            </section>
            {/* Website Link */}
            <section className="pb-15">
              {selectedDate[0]?.attribute_Website && (
                <div>
                  <a
                    href={selectedDate[0].attribute_Website}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }} // Optional: removes underline from the link
                  >
                    <button
                      style={{
                        width: "auto",
                        maxWidth: "100%",
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        letterSpacing: "2.5px",
                        fontSize: ".8rem",
                        height: "40px",
                        background: "#2D2D2D",
                        border: "none",
                        borderRadius: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "25px",
                      }}
                    >
                      {"View Artist Website"}
                    </button>
                  </a>
                </div>
              )}
            </section>
          </div>
          {/* Video */}
          <div
            className="w-full"
            style={{
              fontFamily: "Montserrat, Poppins, sans-serif",
              textTransform: "none",
              fontStyle: "normal",
              color: "white",
              paddingBottom: "10px",
              margin: "0",
            }}
          >
            {selectedDate.length > 0 &&
              selectedDate[0].attribute_VideoLink && ( // Check if video link exists
                <iframe
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    aspectRatio: "16/9",
                  }}
                  src={`https://www.youtube.com/embed/${extractVideoId(
                    selectedDate[0].attribute_VideoLink
                  )}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              )}
          </div>
        </section>
      </div>
    </>
  );
}
